function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export var updateFilterAction = function(name, value, label) {
    return {
        type: 'UpdateFilter',
        payload: {
            name: name,
            value: value,
            label: label
        }
    };
};
export var UpdateFilterLabels = function(name, label) {
    return {
        type: 'UpdateFilterLabels',
        payload: {
            name: name,
            label: label
        }
    };
};
export var updateFilterLabelAction = function(name, label) {
    return {
        type: 'UpdateFilterLabels',
        payload: {
            name: name,
            label: label
        }
    };
};
export var clearAllAction = function(filterKeys) {
    return {
        type: 'ClearAll',
        payload: {
            filterKeys: filterKeys
        }
    };
};
export var getFilterReducer = function() {
    var extraReducer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(newState) {
        return newState;
    };
    return function(state, action) {
        var newState = state;
        var previousState = state;
        switch(action.type){
            case 'UpdateFilter':
                {
                    var _action_payload = action.payload, name = _action_payload.name, value = _action_payload.value, label = _action_payload.label;
                    newState = _object_spread_props(_object_spread({}, state), {
                        filter: _object_spread_props(_object_spread({}, state.filter), _define_property({}, name, {
                            value: value,
                            label: label
                        }))
                    });
                    if (value === undefined || Array.isArray(value) && value.length === 0) {
                        delete newState.filter[name];
                    }
                    break;
                }
            case 'UpdateFilterLabels':
                {
                    var _state_filter_name;
                    var _action_payload1 = action.payload, name1 = _action_payload1.name, label1 = _action_payload1.label;
                    newState = state;
                    if (((_state_filter_name = state.filter[name1]) === null || _state_filter_name === void 0 ? void 0 : _state_filter_name.value) !== undefined) {
                        newState = _object_spread_props(_object_spread({}, state), {
                            filter: _object_spread_props(_object_spread({}, state.filter), _define_property({}, name1, _object_spread_props(_object_spread({}, state.filter[name1]), {
                                label: label1
                            })))
                        });
                    }
                    break;
                }
            case 'ClearAll':
                {
                    var filterKeys = action.payload.filterKeys;
                    newState = _object_spread({}, state);
                    filterKeys.forEach(function(key) {
                        delete newState.filter[key];
                    });
                    break;
                }
        }
        return extraReducer(newState, previousState, action);
    };
};
